export default "__VITE_ASSET__BA1NRfT9__"